
import BaseModel from './BaseModel';
import { getMomentDate } from '../utils/commonUtils';

export default class TagGroupDetail extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.setData(data)
  }

  setData(data = this.__data__) {
    this.id = data.id || undefined;
    this.name = data.name || this.translate.name || undefined;
    this.tagGroupId = data.tagGroupId || undefined;
    this.order = data.order || 0;
    this.color = data.color || '#333333';
    this.bgColor = data.bgColor || '#fafafa';
    this.icon = data.icon || undefined;
    this.setSkus(data);
    this.createdDate = getMomentDate(data.createdDate);
    this.isActive = typeof data.isActive === 'boolean' ? data.isActive : true;
  }

  setSkus(data = {}) {
    this.tagGroupDetailSkus = (data.tagGroupDetailSkus || []).map(item => new TagGroupDetailSku(item));
  }

  export(hasTranslate = false) {
    const result = super.export({
      id: this.id,
      name: this.name,
      tagGroupId: this.tagGroupId,
      order: this.order,
      color: this.color,
      bgColor: this.bgColor,
      icon: this.icon,
      tagGroupDetailSkus: (this.tagGroupDetailSkus || []).map(sku => sku.export()),
      createdDate: this.createdDate && this.createdDate.toISOString(),
      isActive: this.isActive
    });
    if (hasTranslate) result.translate = () => {
      return {
        id: this.translate.id,
        tagGroupDetailId: this.id || this.translate.tagGroupDetailId,
        name: this.name,
        languageCode: this.languageCode,
      }
    }
    return result;
  }
}

export class TagGroupDetailSku {
  constructor(data = {}) {
    this.setData(data)
  }

  setData(data = {}) {
    this.id = data.id || undefined;
    this.name = data.name || undefined;
    this.code = data.code || data.groupCode || data.vinWonderCode || undefined;
    this.tagGroupDetailId = data.tagGroupDetailId || undefined;
    this.skuId = data.skuId || undefined;
    this.supplierId = data.supplierId || undefined;
    this.supplierName = data.supplierName || undefined;
    this.rateCodes = data.rateCodes || undefined;
    this.type = data.type || undefined;
    this.createdDate = getMomentDate(data.createdDate);
    this.deletedDate = getMomentDate(data.deletedDate);
    // this.expiredDateRate = data.expiredDateRate ? data.expiredDateRate[0].expiredDate : null;
    // this.expiredDateSku = data.expiredDateSku ? data.expiredDateSku[0].expiredDate : null;
    this.isActiveListing = data.isActiveListing || false;
  }

  export() {
    return {
      id: this.id,
      tagGroupDetailId: this.tagGroupDetailId,
      skuId: this.skuId,
      rateCodes: this.rateCodes,
      type: this.type,
      createdDate: this.createdDate && this.createdDate.toISOString(),
      deletedDate: this.deletedDate && this.deletedDate.toISOString(),
    }
  }
}

export class TagListOfGroup {
  constructor(data = {}) {
    this.setData(data)
  }

  setData(data = {}) {
    this.id = data.id || undefined;
    this.tagI18n = data.tagI18n || undefined;
  }

  export() {
    return {
      id: this.id,
      tagI18n: this.tagI18n
    }
  }
}
